/**
 * The app/nav registry. This is DATA, not markup — TopNav renders whatever
 * is in this array. Adding a future business app is adding one entry here,
 * never editing the shell components themselves.
 */

export interface AppRegistryEntry {
  appCode: string;
  label: string;
  path: string;
  /** When set, TopNav hides the entry unless the access evaluator allows read. */
  capability?: string;
}

export const APP_REGISTRY: AppRegistryEntry[] = [
  { appCode: "dashboard", label: "My Stats", path: "/dashboard" },
  { appCode: "crm", label: "CRM", path: "/apps/crm" },
  { appCode: "timesheet", label: "Timesheet", path: "/apps/timesheet", capability: "timesheet.entries" },
  { appCode: "expense", label: "Expense", path: "/apps/expense", capability: "expense.reports" },
];

export function findAppByCode(appCode: string): AppRegistryEntry | undefined {
  return APP_REGISTRY.find((a) => a.appCode === appCode);
}
